import { render, staticRenderFns } from "./ServerOverview.vue?vue&type=template&id=5b4318a8"
import script from "./ServerOverview.vue?vue&type=script&lang=js"
export * from "./ServerOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports